<template>
    <div class="fuwu-account-safe">
      <div class="common-header-wrap">
        <mt-header title="账号安全" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
      <div class="menu-list main-content">
		<div @click='editPasswordVisible=true'>
		    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">修改密码</span></flex-line>
		</div>
		<div @click='editMobileVisible=true'>
		    <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">修改手机</span><span slot="right">{{user.account_phone}}</span></flex-line>
		</div>
        
      </div>

			<!--修改手机-->
			<mt-popup v-model="editMobileVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="修改手机" class="common-header">
          <mt-button slot="left" icon="back" @click="editMobileVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
		<div class='main-content'>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">登录密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password" /></div></flex-line>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">新手机</span><div class="field-line-right" slot="right"><input class="field-input" type="text" v-model="mobile" /></div></flex-line>
			<div class="common-btn mint-button--primary ds-button-large mt-10" @click="updateMobile">提交</div>
		</div>
		</div>
    </mt-popup>

		<!--修改密码-->
			<mt-popup v-model="editPasswordVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="修改密码" class="common-header">
          <mt-button slot="left" icon="back" @click="editPasswordVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
		<div class='main-content'>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">新密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password1" /></div></flex-line>
			<flex-line class="field-line menu-item" :show-border="true"><span class="field-name">确认密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="password2" /></div></flex-line>
			<flex-line :show-border="true">
				<span>验证方式</span>
				<div slot="right">
					<mt-radio
							v-model="verifyType"
							:options="verifyTypeOptions">
					</mt-radio>
				</div>
			</flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">验证码</span><div class="field-line-right" slot="right"><input class="field-input" v-model="verifyCode" /><div @click="sendVerifyCode" class="common-btn send-btn">{{sendStateText}}</div></div></flex-line>
			<div class="common-btn mint-button--primary ds-button-large mt-10" @click="updatePassword">提交</div>
		</div>
		</div>
    </mt-popup>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { sendVerifyCode } from '../../../api/common'
import { editAccountPhone, editAccountPassword } from '../../../api/fuwuManageAccount'
import flexLine from '../../flexLine'
export default {
	components: {
		  flexLine
	},
  name: 'FuwuManageAccount',
  data () {
    return {
      editMobileVisible: false,
      password: '',
      mobile: '',
      editEmailVisible: false,
      email: '',
      editPasswordVisible: false,
      password1: '',
      password2: '',
      verifyType: 'mobile',
      verifyCode: '',
      canSend: true,
      time_interval: false,
      sendStateText: '发送',
      verifyTypeOptions: [
        {
          label: '邮箱',
          value: 'email'
        },
        {
          label: '手机',
          value: 'mobile'
        }
      ]
    }
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  computed: {
    ...mapState({
      user: state => state.fuwu.info
    })
  },
  methods: {
    ...mapMutations({
      fuwuEdit: 'fuwuEdit'

    }),
    updateMobile () {
      editAccountPhone(this.password, this.mobile).then(res => {
        this.fuwuEdit({ account_phone: this.mobile })
        Toast(res.message)
        this.editMobileVisible = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    updateEmail () {
      updateUserEmail(this.password, this.email).then(res => {
        this.fuwuEdit({ email: this.email })
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    updatePassword () {
      editAccountPassword(this.password1, this.password2, this.verifyCode).then(res => {
        Toast(res.message)
        this.editPasswordVisible = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    sendVerifyCode () {
      if (!this.canSend) {
        return
      }
      sendVerifyCode(this.verifyType, 3, 4, this.user.account_name).then(res => {
        this.canSend = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.time_interval = setInterval(function () {
          if (second <= 0) {
            _this.canSend = true
            _this.sendStateText = '发送'
            clearInterval(_this.time_interval)
          } else {
            _this.sendStateText = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
.main-content{background: #fff;padding:0 $pageSpace}
  .fuwu-account-safe {position:relative;z-index:100;
	.btn{width:4rem}
	.common-popup-content{
	      .mint-radiolist {
        display: flex;
        .mint-cell {
          flex: 1;
          .mint-radio-input:checked + .mint-radio-core {
            background-color: #ff9900 !important;
            border-color: #ff9900 !important;
          }
        }
      }
	}
  .menu-list{
  .menu-item {
		.right-arrow{transform: rotate(-90deg);color:#ddd;font-size: .6rem;}
  }
  }
  }
</style>
